import { ApiProperty } from "@nestjs/swagger";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { EmployeeExperienceDetails } from "../employee-details/employee-experience-details.entity";
import { EmployeeIdProofDetails } from "../employee-details/employee-id-proof-details.entity";
import { Product } from "../products/product.entity";
import { PackingMethod } from "../packing-mathods/packing-methods.entity";
import { PackingCategoryEnum } from "@gtpl/shared-models/common-models";
import { FgPriceListCategoryEnum } from "@gtpl/shared-models/masters";
import { FgpriceListLogs } from "./fg-pricelist-logs-entity";
import { SkuCodes } from "../sku-codes/sku-codes.entity";

@Entity('product_price_list')
export class FgpriceList{
    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;

    
  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: false,
    name: "min_price"
  })
  minPrice: number;
  
  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: false,
    name: "mid_price"
  })
  midPrice: number;
  
  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: false,
    name: "high_price"
  })
 highPrice: number;
   
  @Column("boolean", {
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;
  
  @Column("enum", {
    nullable: false,
    name: "category",
    enum:FgPriceListCategoryEnum
  })
  category: FgPriceListCategoryEnum;

  @ManyToOne(type=>SkuCodes, e=>e.fgPriceInfo,{  nullable:false, })
    @JoinColumn({ name:"product_id"})
    productId: SkuCodes;

    // @ManyToOne(type=>PackingMethod, e=>e.fgPriceInfo,{ nullable:false, })
    // @JoinColumn({ name:"pack_style_id"})
    // packingStyleId: PackingMethod;
    @OneToMany(type => FgpriceListLogs, info => info.FgpriceListId, { cascade: true })
    fgPriceInfo: FgpriceListLogs[];
}